import { useIsFreeOrStarterPortal } from 'onboarding-scopes';
import http from 'MeetingsBase/http/apiClient';
const createSalesExtensionGrowthPrompt = () => {
  return http.post('habit-loops/v1/sales-extension/create-growth-modal');
};
export const useCreateSalesExtensionDownloadModal = () => {
  const isStarterOrFreePortal = useIsFreeOrStarterPortal();
  const shouldFetch = isStarterOrFreePortal;
  const createGrowthPrompt = () => {
    if (shouldFetch) {
      return createSalesExtensionGrowthPrompt();
    }
    return Promise.resolve({
      isGrowthModalCreated: false
    });
  };
  return {
    createGrowthPrompt
  };
};